
<template>
  <div>
    <p class="title is-3">Tools</p>
    <p class="subtitle is-5">Tools to help manage common tasks</p>
    <hr>

    <div class="columns is-multiline">
      <!-- Featured -->
      <div class="column is-one-third">
        <router-link class="box" to="/tools/featured" el="div">
          <h4 class="title is-4 center-text">
            <b-icon icon="star" size="is-small"></b-icon>
            <br>Featured
          </h4>
        </router-link>
      </div>
      <!-- weighting -->
      <div class="column is-one-third">
        <router-link class="box" to="/tools/weights" el="div">
          <h4 class="title is-4 center-text">
            <b-icon icon="weight" size="is-small"></b-icon>
            <br>Weighting
          </h4>
        </router-link>
      </div>
      <!-- rounds -->
      <div class="column is-one-third">
        <router-link class="box" to="/tools/rounds" el="div">
          <h4 class="title is-4 center-text">
            <b-icon icon="table" size="is-small"></b-icon>
            <br>Round Names
          </h4>
        </router-link>
      </div>
      <!-- cache -->
      <div class="column is-one-third">
        <router-link class="box" to="/tools/cache" el="div">
          <h4 class="title is-4 center-text">
            <b-icon icon="archive" size="is-small"></b-icon>
            <br>Cache
          </h4>
        </router-link>
      </div>
      <!-- Explorer -->
      <div class="column is-one-third">
        <router-link class="box" to="/tools/explorer" el="div">
          <h4 class="title is-4 center-text">
            <b-icon icon="rocket" size="is-small"></b-icon>
            <br>Feed Explorer
          </h4>
        </router-link>
      </div>
      <!-- History -->
      <div class="column is-one-third">
        <router-link class="box" to="/tools/history" el="div">
          <h4 class="title is-4 center-text">
            <b-icon icon="history" size="is-small"></b-icon>
            <br>History
          </h4>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tools"
};
</script>

<style scoped>
.center-text {
  text-align: center;
}
</style>
